import styled from '@emotion/styled'
import * as React from 'react'

export type AttributeProps = {
  children: React.ReactNode

  name?: React.ReactNode
  /**
   * Use nameComponent to completely override what gets rendered in the name
   */
  nameComponent?: React.ReactNode
}

const StyledAttributeBlock = styled.div`
  padding: 16px 16px;
  border-bottom: dotted 1px var(--White90);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: none;
  }
`

const Item = styled.div`
  color: var(--Graphite);
  margin: 0;
`

const Name = styled(Item)`
  font-weight: 600;
`

export const Attribute = ({ children, name, nameComponent, ...props }: AttributeProps) => (
  <StyledAttributeBlock {...props}>
    {nameComponent || <Name>{name}</Name>}
    <Item>{children}</Item>
  </StyledAttributeBlock>
)
